/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Spacer, Text } from "@nordcloud/gnui";
import styles from "~/assets/styles/Runbook.module.css";
import { Divider } from "~/components/Styled/Divider";
import { Application } from "~/models";

type Props = {
  application: Application;
};

function FleetControlPatchingPlans({ application }: Props) {
  return (
    <Divider>
      <Spacer height="1rem" />

      <Text isTitle weight="medium">
        Fleet Control Patching plans
      </Text>

      {application?.fcPatchPlans?.length < 1 ? (
        <Text mt={3}>No Fleet Control Patching plans</Text>
      ) : (
        <>
          <div className={styles.columnsContainer}>
            <span className={styles.tableHeader}>Customer name</span>
            <span className={styles.tableHeader}>Plan</span>
          </div>

          {application?.fcPatchPlans?.map((fcp, index) => (
            <div key={index} className={styles.columnsContainer}>
              <p className={styles.tableElement}>{fcp?.customerName}</p>
              <p className={styles.tableElement}>{fcp?.plan}</p>
            </div>
          ))}
        </>
      )}
      <Spacer height="1rem" />
    </Divider>
  );
}

export { FleetControlPatchingPlans };
